export const load = () => ({
	title: 'Block Harmful UV Rays',
	h1: 'Easy UV Protection With Window Inserts',
	description:
		'Protect your priceless artwork, furniture, floors and more from fading and UV damage with window inserts.',
	showTitle: true,
});
